import {
  Alert,
  AlertDescription,
  AlertIcon,
  Flex,
  Text,
} from "@chakra-ui/react";
import { t } from "i18next";
import {
  EntraConnectionDto,
  EntraReconciliationMode,
  useGetEntraReconciliationReportQuery,
} from "../../../../autogen/bff-api";

interface Props {
  organizationId: string;
  connection: EntraConnectionDto;
}

export const EntraTenantStatus = ({ organizationId, connection }: Props) => {
  const { data: report } = useGetEntraReconciliationReportQuery({
    orgId: organizationId,
    connectionId: connection.id,
  });

  const confersAccess =
    connection.reconciliation !== EntraReconciliationMode.Off;
  const pending =
    (report?.pendingGrantsToIssue ?? 0) + (report?.pendingGrantsToRevoke ?? 0);
  const disagreements = report?.legacyRoleDisagreements.length ?? 0;

  const lastReconciled = connection.lastReconciledAt
    ? new Date(connection.lastReconciledAt).toLocaleString()
    : null;

  return (
    <Flex flexDir="column" gap="2">
      {!confersAccess && (
        <Alert status="warning" variant="subtle" borderRadius="md">
          <AlertIcon />
          <AlertDescription fontSize="sm">
            {t(
              "These roles are saved, but are not giving access yet. Get in touch and we will switch it on",
            )}
            .
          </AlertDescription>
        </Alert>
      )}

      {confersAccess && (pending > 0 || disagreements > 0) && (
        <Alert status="info" variant="subtle" borderRadius="md">
          <AlertIcon />
          <AlertDescription fontSize="sm">
            {t(
              "Some access has not caught up with these roles yet. It settles on the next change from Entra ID",
            )}
            .
          </AlertDescription>
        </Alert>
      )}

      {confersAccess && lastReconciled && (
        <Text fontSize="xs" color="smMuted">
          {t("Access last brought in line with Entra ID {{when}}", {
            when: lastReconciled,
          })}
        </Text>
      )}
    </Flex>
  );
};
